var path = 'app/scripts/modules/core/src/application/modal/platformHealthOverrideCheckbox.directive.html';
var html = "<div class=\"checkbox\">\n  <label>\n    <input type=\"checkbox\"\n           init-platform-health\n           ng-click=\"clicked($event)\"/>\n    Consider only {{platformHealthType}} health\n  </label>\n  <help-field key=\"application.platformHealthOnly\" expand=\"showHelpDetails\"></help-field>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/application/modal/platformHealthOverrideCheckbox.directive.html
// module id = 963
// module chunks = 0